import {
  ActivityModel,
  ActivityVisualTypesEnum,
  BasicActivityTypesEnum,
  BasicVisualTypesEnum,
} from '../../../../../src/models/api/activityModel';
import {ActivitySourceVisualTypesEnum} from '../../../../../src/models/api/activitySourceModel';
import {ConversationTeamStatusesEnum} from '../../../../../src/models/api/conversationCommonTypes';
import {ConversationModel} from '../../../../../src/models/api/conversationModel';
import {ReminderModel} from '../../../../../src/models/api/reminderModel';
import {CellsContextTypesEnum} from '../../../../../src/store/panels/cells/context/cellsContext';
import {ViewerPanelPageState} from '../../../../../src/store/panels/viewer/viewerPanelState';

export interface StaticViewerReminder {
  reminder: ReminderModel;
  teammateName: string;
}

export function computeActivityTypeForTeamStatus(teamStatus: ConversationTeamStatusesEnum) {
  if (teamStatus === ConversationTeamStatusesEnum.ARCHIVED) {
    return BasicActivityTypesEnum.ARCHIVE;
  }

  if (teamStatus === ConversationTeamStatusesEnum.TRASHED) {
    return BasicActivityTypesEnum.TRASH;
  }

  return undefined;
}

/** Filters the array of activities from the timeline as to remove the last activity of the list if it's responsible for a StaticViewer being shown. */
export function filterStaticViewerRelatedActivities(
  conversation: ConversationModel,
  page: ViewerPanelPageState,
  activity: ActivityModel,
  index: number,
  array: ReadonlyArray<ActivityModel>,
): boolean {
  const {cellsContext} = page;

  // If our conversation is not in a teammate context, nothing to do.
  if (cellsContext.type !== CellsContextTypesEnum.TEAMMATE) {
    return true;
  }

  // If our activity isn't the last, nothing to do.
  if (index < array.length - 1) {
    return true;
  }

  // If the activity isn't a basic activity, nothing to do.
  if (activity.visualType !== ActivityVisualTypesEnum.BASIC) {
    return true;
  }

  // If the activity is reminder activity, try to find a team reminder associated with it.
  if (
    activity.basicVisualType === BasicVisualTypesEnum.REMINDER &&
    activity.source.visualType === ActivitySourceVisualTypesEnum.TEAMMATE
  ) {
    const activitySourceTeammateId = activity.source.teammateId;
    const teamReminder = conversation.reminders.find(
      (r) => r.isTeamReminder && r.teammateId === activitySourceTeammateId,
    );

    return !teamReminder;
  }

  // If the activity is an archive activity AND the conversation is team archived, then we can hide it.
  if (
    activity.type === BasicActivityTypesEnum.ARCHIVE &&
    conversation.teamStatus === ConversationTeamStatusesEnum.ARCHIVED
  ) {
    return false;
  }

  // If the activity is a trash activity AND the conversation is team trashed, then we can hide it.
  if (
    activity.type === BasicActivityTypesEnum.TRASH &&
    conversation.teamStatus === ConversationTeamStatusesEnum.TRASHED
  ) {
    return false;
  }

  return true;
}
